/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum ProvenanceType {
  COMPOSITION = "composition",
  IMPURITIES = "impurities",
  ALLERGENS = "allergens",
  COUNTRY_OF_MANUFACTURE = "country_of_manufacture",
  COUNTRY_OF_ORIGIN = "country_of_origin",
  INGREDIENT_SOURCE = "ingredient_source",
}
